import React, { useEffect, useState } from 'react';
import { Grid, GridColumn, Icon } from 'semantic-ui-react';
import FileUploader from 'devextreme-react/file-uploader';
import { BASE_URL_UPLOAD } from '../../api';

const HtmlUploader = ({ data, Url, isGeneral }) => {
    const [showFilesList, setShowFilesList] = useState(true);
    const uploadUrl = Url ? `${BASE_URL_UPLOAD}${Url}` : `${BASE_URL_UPLOAD}/doc/upload`;
    const allowedFileExtensions = ['.html'];

    useEffect(() => {
        let open = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function () {
            open.apply(this, arguments);
            this.withCredentials = true;
        };
    }, []);

    const onUploaded = (e) => {
        data.setValue(JSON.parse(e.request.response).docUrl);
    };

    return (
        <div>
            <Grid columns='2' stackable verticalAlign='middle'>
                <GridColumn width='13'>
                    <FileUploader
                        accept="text/html"
                        allowedFileExtensions={allowedFileExtensions}
                        uploadMode="instantly"
                        uploadUrl={uploadUrl}
                        showFileList={showFilesList}
                        allowCanceling
                        visible
                        name='doc'
                        activeStateEnabled
                        uploadCustomData={{
                            accessTerm: isGeneral && 'PUBLIC'
                        }}
                        onUploaded={onUploaded}
                        onValueChanged={() => setShowFilesList(true)}
                    />
                </GridColumn>

                {data.value && <GridColumn width='3'>
                    <a title={data.value} href={data.value} target='_blank' rel='noreferrer'><Icon size='big' name='file alternate' link /></a>
                </GridColumn>}

            </Grid>
        </div>
    );
};



export default HtmlUploader;